import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../../../Utility/constants";
import AdminHeader from "../../../common/AdminHeader";
import Footer from "../../../common/Footer";
import { PageSize } from "../../../../Utility/constants";
import { Button, Table, Pagination, Modal, Form } from "react-bootstrap";
import { getSchoolId } from "../../../../Utility/commonFunctions";


const TeacherClassSubjectMappingPage = () => {
  const role = localStorage.getItem("Role");
  const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;
  const sectionApiUrl = `${baseUrl}/api/SectionMaster/GetSectionByStandardID`;
  const subjectGroupApiUrl = `${baseUrl}/api/CommonMaster/GetSubjectGroupMasters`;

  const [subjects, setSubjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [selectedStandardId, setSelectedStandardId] = useState("");
  const [subjectGroups, setSubjectGroups] = useState([]);
  const [selectedSubjectGroup, setSelectedSubjectGroup] = useState('');
  const [teachersData, setTeachersData] = useState([]);
  const [standards, setStandards] = useState([]);
  const [sections, setSections] = useState([]);
  const [streams, setStreams] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [formData, setFormData] = useState({
    id: 0,
    teacherId: "",
    standardId: "",
    sectionId: "",
    streamId: null,
    subjectID: "",
    subjectGroupId: null,
    isClassTeacher: 0,
    createdBy: localStorage.getItem("userID"),
    updatedBy: localStorage.getItem("userID"),
    createdOn: new Date().toISOString(),
    updatedOn: new Date().toISOString(),
    isActive: true,
  });
  const [standardValue, setStandardValue] = useState('');
  const loggedUserId = localStorage.getItem("userID");
  const loggedInUserId = localStorage.getItem("loggedInUserId");

  useEffect(() => {
    fetchSubjectGroups();
    fetchAdminSchoolId();
    fetchTeachersData();
    fetchData();
  }, []);

  const fetchSubjectGroups = async () => {
    try {
      const url = subjectGroupApiUrl;
      const response = await axios.get(url);
      if (
        response &&
        response.data &&
        response.data.length > 0
      ) {
        setSubjectGroups(response.data);
      }
      else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const fetchAdminSchoolId = async () => {
    try {
      const url = `${baseUrl}/api/PersonalDetails/PersonalDetailsByAdmin?AdminId=${localStorage.getItem(
        "userID"
      )}`;
      const response = await axios.get(url);
      if (response && response.data && response.data && response.data.length > 0) {
        setSchoolId(response.data[0].schoolId);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  // Fetch standards based on schoolId
  useEffect(() => {
    const loadSchoolDetails = async () => {
      try {
        debugger
        const school_Id = await getSchoolId();
        if (school_Id) {
          axios
            .get(`${standardApiUrl}?id=${school_Id}`)
            .then((response) => setStandards(response.data))
            .catch(() => console.log("Error fetching standards"));
        }
      } catch (error) {
        console.log("Failed to load school details.", error);
      }
    };
    loadSchoolDetails();

  }, [schoolId]);

  // Fetch sections based on selected standard ID
  useEffect(() => {
    if (selectedStandardId) {
      axios
        .get(`${sectionApiUrl}?id=${selectedStandardId}`)
        .then((response) => setSections(response.data))
        .catch(() => console.log("Error fetching sections"));
      setSelectedStandardId(selectedStandardId);
    }
  }, [selectedStandardId]);

  const fetchTeachersData = async () => {
    try {
      const url = `${baseUrl}/api/Teachers/ReturnTeacherNames`;
      const response = await axios.get(url);
      if (
        response &&
        response.data &&
        response.data.length > 0
      ) {
        const sortedByName = response.data.sort((a, b) => a.fullName.localeCompare(b.fullName));
        setTeachersData(sortedByName);
      }
      else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const selectedStandard = standards.find(x => x.id === parseInt(formData.standardId));
    const standardValue = selectedStandard?.standardName || "";

    // For Standard below 11
    if (standardValue < 11) {
      if (!formData.standardId) return;
      if (!formData.sectionId) return;
      if (formData.standardId && formData.sectionId) {
        fetchSubjects(standardValue);
      }
    }

    // For Standard 11 and above
    else {
      if (!formData.standardId) return;
      if (!formData.streamId) return;
      if (!selectedSubjectGroup) return;
      if (formData.standardId && formData.streamId && selectedSubjectGroup
      ) {
        fetchSubjects(standardValue);
      }
    }
  }, [
    formData.standardId,
    formData.sectionId,
    formData.streamId,
    selectedSubjectGroup,
  ]);

  const fetchSubjects = async (standardValue) => {
    try {

      let url = "";

      // Standard below 11
      if (standardValue < 11) {
        url = `${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStream?classId=${formData.standardId}`;
      }

      // Standard 11 and above
      else {
        url = `${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStream?classId=${formData.standardId}&streamId=${formData.streamId}&subjectGroup=${selectedSubjectGroup}`;
      }

      const response = await axios.get(url);
      setSubjects(response.data);
    } catch (error) {
      console.error("Error fetching subjects", error);
    }
  };

  useEffect(() => {
    axios
      .get(`${baseUrl}/api/StreamMaster`)
      .then((response) => setStreams(response.data))
      .catch(() => console.log("Error fetching stream details"));
  }, []);

  const fetchData = async () => {
    try {
      const url = role === "ADMIN" ? `${baseUrl}/api/TeacherSubjectClassDetails`
        : `${baseUrl}/api/TeacherSubjectClassDetails/GetTeacherSubjectClassDetailsByTeacherId?teacherId=${loggedUserId}`;

      const response = await axios.get(`${url}`);
      setData(response.data || []);
    } catch (error) {
      toast.error("Error fetching data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "standardId") {
      setSelectedStandardId(value);
      setStandardValue(e.target.options[e.target.selectedIndex].text);
    }

    if (name === "subjectGroupId") setSelectedSubjectGroup(value);

    let newValue;

    if (name === "isClassTeacher") {
      newValue = checked ? 1 : 0;
    }
    else if (
      ["teacherId", "standardId", "sectionId", "streamId", "subjectID", "subjectGroupId"].includes(name)
    ) {
      newValue = value === "" ? null : Number(value);
    }
    else {
      newValue = value;
    }

    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }));
  };

  const openAddModal = () => {
    setEditingId(null);
    debugger
    setFormData({
      id: 0,
      teacherId: role === "ADMIN" ? "" : loggedInUserId,
      standardId: "",
      sectionId: "",
      streamId: null,
      subjectID: "",
      subjectGroupId: null,
      isClassTeacher: 0,
      createdBy: localStorage.getItem("userID"),
      updatedBy: localStorage.getItem("userID"),
      createdOn: new Date().toISOString(),
      updatedOn: new Date().toISOString(),
      isActive: true,
    });
    setModalOpen(true);
  };

  const openEditModal = (item) => {
    setEditingId(item.id);
    setModalOpen(true);
    fetchTeacherDataById(item.id);
  };

  const fetchTeacherDataById = async (teacherId) => {
    try {

      const response = await axios.get(`${baseUrl}/api/TeacherSubjectClassDetails/${teacherId}`);
      const data = response.data;

      // Set related values for dependent dropdowns before setting form
      setSelectedStandardId(data.standardId); // will trigger fetchSection
      setSelectedSubjectGroup(data.subjectGroupId); // will be used to fetch subjects

      // Ensure subjects & sections are loaded first
      await Promise.all([
        axios.get(`${sectionApiUrl}?id=${data.standardId}`).then(res => setSections(res.data)),
        // axios.get(`${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStream?classId=${data.standardId}&streamId=${data.streamId}&subjectGroup=${data.subjectGroupId}`)
        axios.get(`${baseUrl}/api/SubjectMaster/GetSubjectTeacherMappingById?mappingId=${teacherId}`)
          .then(res => setSubjects(res.data))
      ]);

      // Now set the form data
      setFormData({
        ...data,
        createdBy: localStorage.getItem("userID"),
        updatedBy: localStorage.getItem("userID"),
        createdOn: new Date().toISOString(),
        updatedOn: new Date().toISOString(),
      });
    } catch (error) {
      toast.error("Error fetching teacher mapping data");
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        await axios.delete(`${baseUrl}/api/TeacherSubjectClassDetails/${id}`);
        toast.success("Deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        streamId: formData.streamId === "" ? null : Number(formData.streamId),
        standardId: formData.standardId === "" ? null : Number(formData.standardId),
        sectionId: formData.sectionId === "" ? null : Number(formData.sectionId),
        subjectGroupId: formData.subjectGroupId === "" ? null : Number(formData.subjectGroupId),
        teacherId: Number(formData.teacherId),
        subjectID: Number(formData.subjectID),
        createdOn: new Date().toISOString(),
        updatedOn: new Date().toISOString(),
        createdBy: localStorage.getItem("userID"),
        updatedBy: localStorage.getItem("userID"),
        isActive: true,
      };

      let response;
      if (editingId) {
        response = await axios.put(`${baseUrl}/api/TeacherSubjectClassDetails/${editingId}`, payload);
        toast.success("Updated successfully");
      } else {
        response = await axios.post(`${baseUrl}/api/TeacherSubjectClassDetails`, payload);
        toast.success("Added successfully");
      }

      setModalOpen(false);
      fetchData();
    } catch (error) {
      if (error?.response?.status === 409) {
        toast.error(error?.response?.data);
      } else {
        toast.error("Operation failed");
      }
    }
  };

  // Calculate total pages
  const totalPages = Math.ceil(data.length / PageSize);

  // Calculate current data slice
  const currentData = data.slice(
    (currentPage - 1) * PageSize,
    currentPage * PageSize
  );

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5 mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Teacher Class Subject Mapping</h4>
          {/* {role === "ADMIN" && */}
          <button className="btn btn-primary" onClick={openAddModal}>
            Add New
          </button>
          {/* } */}
        </div>

        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th style={{ width: "50px" }}>#</th>
              <th style={{ width: "300px" }}>Teacher Name</th>
              <th style={{ width: "100px" }}>Standard</th>
              <th style={{ width: "100px" }}>Section</th>
              <th style={{ width: "150px" }}>Stream</th>
              <th style={{ width: "150px" }}>Subject</th>
              <th style={{ width: "150px" }}>ClassTeacher</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * PageSize + index + 1}</td>
                  <td>{item.fullName}</td>
                  <td>{item.class}</td>
                  <td>{item.section}</td>
                  <td>{item.stream}</td>
                  <td>{item.subject}</td>
                  <td>{item.isClassTeacher === 1 ? "Yes" : "No"}</td>
                  <td>
                    <button className="btn btn-sm btn-warning me-2" onClick={() => openEditModal(item)}>
                      Edit
                    </button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">No records found</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination Controls */}
        < Pagination className="justify-content-center" >
          <Pagination.First
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {
            [...Array(totalPages)].map((_, i) => (
              <Pagination.Item
                key={i}
                active={i + 1 === currentPage}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))
          }
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination >


        {/* Modal */}
        {modalOpen && (

          <div
            className="modal show fade"
            tabIndex="-1"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">{editingId ? "Edit Mapping" : "Add Mapping"}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setModalOpen(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Teacher</label>
                        <select
                          className="form-select"
                          name="teacherId"
                          value={formData.teacherId}
                          onChange={handleInputChange}
                          required
                          disabled={role !== "ADMIN"}
                        >
                          <option value="">Select Teacher</option>
                          {teachersData.map((teacher) => (
                            <option key={teacher.id} value={teacher.id}>
                              {teacher.fullName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Standard</label>
                        <select
                          className="form-select"
                          name="standardId"
                          value={formData.standardId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Standard</option>
                          {standards.map((std) => (
                            <option key={std.id} value={std.id}>
                              {std.standardName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Section</label>
                        <select
                          className="form-select"
                          name="sectionId"
                          value={formData.sectionId}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Section</option>
                          {sections.map((sec) => (
                            <option key={sec.id} value={sec.id}>
                              {sec.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Stream</label>
                        <select
                          className="form-select"
                          name="streamId"
                          value={formData.streamId}
                          onChange={handleInputChange}
                          // disabled={formData.standardId && Number(formData.standardId) <= 10}
                          disabled={standardValue && Number(standardValue) <= 10}
                        >
                          <option value="">Select Stream</option>
                          {streams.map((stream) => (
                            <option key={stream.id} value={stream.id}>
                              {stream.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Subject Group</label>
                        <select
                          className="form-select"
                          value={formData.subjectGroupId}
                          name="subjectGroupId"
                          onChange={handleInputChange}
                          // disabled={formData.standardId && Number(formData.standardId) <= 10}
                          disabled={standardValue && Number(standardValue) <= 10}
                        >
                          <option value="">Select Subject Group</option>
                          {subjectGroups.map((group) => (
                            <option key={group.subjectGroupId} value={group.subjectGroupId}>
                              {group.subjectGroupName}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Subject</label>
                        <select
                          className="form-select"
                          name="subjectID"
                          value={formData.subjectID}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Subject</option>
                          {/* {subjects.map((sub) => (
                            <option key={sub.subjectId} value={sub.subjectId}>
                              {sub.subjectCode}-{sub.subjectName}
                            </option>
                          ))} */}
                          {[...subjects]
                            .sort((a, b) => a.subjectCode.localeCompare(b.subjectCode))
                            .map((sub) => (
                              <option key={sub.subjectId} value={sub.subjectId}>
                                {sub.subjectCode}-{sub.subjectName}
                              </option>
                            ))
                          }
                        </select>
                      </div>
                    </div>

                    <div className="form-check mb-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="isClassTeacher"
                        checked={formData.isClassTeacher === 1}
                        onChange={handleInputChange}
                      />
                      <label className="form-check-label">Is Class Teacher</label>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button type="submit" className="btn btn-success">
                      {editingId ? "Update" : "Add"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setModalOpen(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default TeacherClassSubjectMappingPage;
